module.exports = __webpack_public_path__ + "img/4.43c81aac.jpg";